(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'relatedOptions', {
            bindings: {
                content: '<'
            },
            templateUrl: 'app/views/partials/content/related-options.html',
            controller:   relatedOptionsController,
            controllerAs: 'vm',
            renderingOptions: {
                'related-options': {
                    inputs:    [
                        'content="::content.asset_contents"',
                    ],
                    classes: [
                        'block-container',
                        'centraliser',
                        'block__study-options'
                    ],
                    wrapStart:  '<div class="centraliser">',
                    wrapEnd:    '</div>'
                }
            }
        });


    /**
     * Lists all qualifications that are directly related to the given subject.
     *
     * @param {ng.IScope} $scope
     */
    function relatedOptionsController( $scope ){


        /* ===== EXPOSE TO THE SCOPE ======================================== */


        /** @constant */
        $scope.BLOCK_TYPE     = {
            TEXT: 'plain',
            CARD: 'card'
        };
    }


    relatedOptionsController.$inject = [ '$scope' ];
})();
